(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function marcar(el) {
    if (el.dataset.mtInit) return false;
    el.dataset.mtInit = '1';
    return true;
  }

  function initReveals(raiz) {
    var els = raiz.querySelectorAll('.mt-reveal, [data-mt-observar]');
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('mt-visible')) observador.observe(el); });
  }

  /* Frase que se ilumina palabra a palabra */
  function initFrases(raiz) {
    raiz.querySelectorAll('[data-mt-frase]').forEach(function (el) {
      if (!marcar(el)) return;
      el.classList.remove('mt-frase--sinjs');
      if (reducido) return;
      var palabras = el.querySelectorAll('.mt-palabra');
      function pintar() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var progreso = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        progreso = Math.max(0, Math.min(1, progreso));
        var n = Math.round(progreso * palabras.length);
        palabras.forEach(function (p, i) { p.classList.toggle('mt-on', i < n); });
      }
      window.addEventListener('scroll', pintar, { passive: true });
      window.addEventListener('resize', pintar);
      pintar();
    });
  }

  /* Hotspots: punto <-> tarjeta */
  function initHotspots(raiz) {
    raiz.querySelectorAll('[data-mt-hot]').forEach(function (el) {
      if (!marcar(el)) return;
      var puntos = el.querySelectorAll('[data-mt-punto]');
      var items = el.querySelectorAll('[data-mt-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtPunto === i); });
        items.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtItem === i); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { activar(p.dataset.mtPunto); });
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtPunto); });
      });
      items.forEach(function (p) {
        p.addEventListener('click', function () { activar(p.dataset.mtItem); });
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtItem); });
      });
      if (items.length) activar(items[0].dataset.mtItem);
    });
  }

  /* Antes / después */
  function initComparadores(raiz) {
    raiz.querySelectorAll('[data-mt-ad]').forEach(function (marco) {
      if (!marcar(marco)) return;
      var asa = marco.querySelector('.mt-ad__asa');
      var pos = parseFloat(marco.dataset.mtInicio || '50');
      function poner(p) {
        pos = Math.max(0, Math.min(100, p));
        marco.style.setProperty('--mt-pos', pos + '%');
        if (asa) asa.setAttribute('aria-valuenow', Math.round(pos));
      }
      function desdeEvento(e) {
        var r = marco.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        poner((x / r.width) * 100);
      }
      var arrastrando = false;
      marco.addEventListener('pointerdown', function (e) { arrastrando = true; desdeEvento(e); });
      window.addEventListener('pointermove', function (e) { if (arrastrando) desdeEvento(e); });
      window.addEventListener('pointerup', function () { arrastrando = false; });
      if (asa) asa.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { poner(pos - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { poner(pos + 5); e.preventDefault(); }
      });
      poner(pos);
    });
  }

  /* FAQ */
  function initFaq(raiz) {
    raiz.querySelectorAll('[data-mt-faq]').forEach(function (lista) {
      if (!marcar(lista)) return;
      lista.querySelectorAll('.mt-faq__pregunta').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.mt-faq__item');
          var abierto = item.classList.toggle('mt-abierto');
          btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });
    });
  }

  /* Página de producto: galería, variantes y cantidad */
  function formatear(centimos, plantilla) {
    var valor = (centimos / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    return (plantilla || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100))
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto(raiz) {
    raiz.querySelectorAll('[data-mt-producto]').forEach(function (el) {
      if (!marcar(el)) return;
      var principal = el.querySelector('[data-mt-principal]');
      var minis = el.querySelectorAll('[data-mt-mini]');
      function verFoto(src, idMedia) {
        if (!principal || !src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.toggle('mt-activo', m.dataset.mtMedia === String(idMedia)); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { verFoto(m.dataset.mtMini, m.dataset.mtMedia); });
      });

      var datos = el.querySelector('[data-mt-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = el.dataset.mtMoneda;
      var campoId = el.querySelector('input[name="id"]');
      var precio = el.querySelector('[data-mt-precio]');
      var tachado = el.querySelector('[data-mt-tachado]');
      var boton = el.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.dataset.mtTexto : '';
      var textoAgotado = boton ? boton.dataset.mtAgotado : '';

      function actualizar() {
        var elegidas = [];
        el.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var marcada = grupo.querySelector('input:checked');
          elegidas.push(marcada ? marcada.value : null);
          var rotulo = grupo.querySelector('[data-mt-valor]');
          if (rotulo && marcada) rotulo.textContent = marcada.value;
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) return;
        if (campoId) campoId.value = v.id;
        if (precio) precio.textContent = formatear(v.price, formato);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = formatear(v.compare_at_price, formato); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado; }
        if (v.featured_media) verFoto(v.featured_media.src, v.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      el.querySelectorAll('[data-mt-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cantidad = el.querySelector('[data-mt-cantidad]');
      if (cantidad) {
        var input = cantidad.querySelector('input');
        cantidad.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value || '1', 10) + parseInt(b.dataset.mtPaso, 10);
            input.value = Math.max(1, n);
          });
        });
      }
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(raiz);
    initFrases(raiz);
    initHotspots(raiz);
    initComparadores(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
